export default __webpack_public_path__ + "static/media/compact_line.e96499f0.png";